import { useSyncExternalStore } from "react";
import { isReconnecting, subscribeReconnecting } from "@/shared/api/renewal";
import { Alert } from "@/shared/ui/alert";

/**
 * The one thing a person sees when the session could not be renewed for a blip — a Wi-Fi drop, a
 * deploy, a busy server (ADR-0011 addendum 2026-10-04, plan §5.2). Never the sign-in page: they are
 * still signed in, and the client keeps trying on its own, so this clears by itself. A slim strip under
 * the top bar, shown whatever else the shell is showing (a suspended organisation included).
 */
export function ReconnectingNotice() {
  const reconnecting = useSyncExternalStore(subscribeReconnecting, isReconnecting, () => false);
  if (!reconnecting) return null;
  return (
    <Alert tone="info" className="rounded-none border-x-0 border-t-0 px-4 py-2 md:px-6">
      <span className="font-medium">Reconnecting…</span> You're still signed in; this clears by itself once
      the connection is back.
    </Alert>
  );
}
